export const apiProcessOrderResponseTreatments = {
  ORDER_IS_INACTIVE_WITHOUT_VOUCHER_ID:
    'É obrigatório o envio de um voucherId para orders de tipo inativas',
  ORDER_PENDING: 'Ordem enviada está pendente',
  ERROR_WHEN_CONSUMING: 'Houve um erro ao tentar consumir a ordem',
  TEMPLATE_NOT_SENDED: 'Template da promoção não foi enviado',
  CLIENT_NOT_SENDED: 'Cliente da promoção não foi enviado',
  TEMPLATE_NOT_FOUND: 'Não foi possível encontrar o template da promoção enviada!',
  ESTABLISHMENT_NOT_FOUND: 'Não foi possível encontrar o estabelecimento da promoção enviada!',
  ERROR_WHEN_CREATING_CONTRACT: 'Houve um erro ao criar um contrato para o estabelecimento',
  GROUP_NOT_FOUND: 'Não foi possível encontrar o grupo do template enviado',
  OUT_OF_STOCK: 'Estoque insuficiente',
  BLOCK_UNIQUE_CONSUME: 'Bloqueio de consumo único',
  BLOCK_SIMULTANEOUS: 'Bloqueio de quantidade simultânea',
  BLOCK_COOLDOWN: 'Bloqueio por cooldown',
  ERROR_WHEN_CLAIMING_VOUCHER: 'Houve um erro ao resgatar o voucher',
};

